import { onBeforeUnmount, onMounted } from 'vue';

const CTA_SELECTOR = '[data-lp-cta]';

const loadPixel = pixelId => {
  if (!window.fbq) {
    const stub = (...args) => {
      if (typeof stub.callMethod === 'function') {
        stub.callMethod(...args);
      } else {
        stub.queue.push(args);
      }
    };
    stub.push = stub;
    stub.loaded = true;
    stub.version = '2.0';
    stub.queue = [];
    window.fbq = stub;
    // Pixel oficial da Meta usa window._fbq.
    // eslint-disable-next-line no-underscore-dangle
    window._fbq = stub;
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
  }
  window.fbq('init', pixelId);
  window.fbq('track', 'PageView');
};

// Pixel do Meta do revendedor: PageView ao abrir e, no clique do botão principal,
// o evento escolhido para a página.
export function useMetaPixel(landing) {
  if (!landing.metaPixelId) return;

  const onClick = event => {
    if (!landing.cta.metaEvent || !event.target.closest(CTA_SELECTOR)) return;
    window.fbq(
      'track',
      landing.cta.metaEvent,
      { content_name: landing.page },
      { eventID: `${landing.page}_${Date.now()}` }
    );
  };

  onMounted(() => {
    loadPixel(landing.metaPixelId);
    document.addEventListener('click', onClick, true);
  });

  onBeforeUnmount(() => {
    document.removeEventListener('click', onClick, true);
  });
}
